<ui-card class="interview-card">
    <app-segment-header title="applicant-tracker.details" />
    <div class="margin-top-1 margin-bottom-2">
        {{ 'applicant-tracker.messages.interview.giveThisInterviewAName' | translate }}
    </div>
    <form #form="ngForm" class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.name' | appTranslate }}</mat-label>
            <input type="text" required matInput #name="ngModel" name="name" [(ngModel)]="interview.name" />
            <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.description' | appTranslate }}</mat-label>
            <textarea
                matInput
                #description="ngModel"
                name="description"
                [(ngModel)]="interview.description"
                rows="7"
            ></textarea>
            <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
        </mat-form-field>
    </form>
</ui-card>
